import React from 'react';
import { useTranslation } from 'react-i18next';

const CTASection = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';

  const stats = [
    {
      value: '2',
      labelKo: '지원 시장',
      labelEn: 'Markets Supported',
      copyKo: '한국, 미국',
      copyEn: 'Korea, U.S.'
    },
    {
      value: '91.58%',
      labelKo: 'AI F1 Score',
      labelEn: 'AI F1 Score',
      copyKo: '지속 업데이트되는 데이터로 학습',
      copyEn: 'Trained on a continuously updated dataset',
      point: true
    },
    {
      value: isKo ? '즉시' : 'Instant',
      labelKo: '검증 소요 시간',
      labelEn: 'Validation time',
      copyKo: '컨설팅 2~4주 → 즉시',
      copyEn: 'Consulting 2–4 weeks → instant'
    }
  ];

  return (
    <section style={{ padding: '72px 0' }}>
      <div className="wrap" style={{ textAlign: 'center' }}>
        <div className="section-head" style={{ marginBottom: 40 }}>
          <h2>{isKo ? '글로벌 진출,' : 'Expand globally,'}</h2>
          <h3>{isKo ? '지금 바로 VeriPass와 시작하세요' : 'start with VeriPass today'}</h3>
        </div>
        <div className="stats">
          {stats.map((s, i) => (
            <div key={i}>
              <div className={`stat-value${s.point ? ' point' : ''}`}>{s.value}</div>
              <div className="stat-label">{isKo ? s.labelKo : s.labelEn}</div>
              <div className="stat-copy">{isKo ? s.copyKo : s.copyEn}</div>
            </div>
          ))}
        </div>
        <a className="btn btn-primary" href="/login?signup=true">
          {isKo ? '무료로 시작하기' : 'Start Free'}
        </a>
        <p style={{ marginTop: 16, color: '#6b7280' }}>
          {isKo ? '신용카드 없이 바로 시작 가능' : 'Start without a credit card'}
        </p>
      </div>
    </section>
  );
};

export default CTASection;
